import { render, staticRenderFns } from "./valentinesModal.vue?vue&type=template&id=0b6c6256&scoped=true&"
import script from "./valentinesModal.vue?vue&type=script&lang=js&"
export * from "./valentinesModal.vue?vue&type=script&lang=js&"
import style0 from "./valentinesModal.vue?vue&type=style&index=0&id=0b6c6256&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c6256",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
